module.exports = __webpack_public_path__ + "img/horse-head.5a4417b1.svg";